import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ElioSvgIconsModule } from '@elio/shared/icon-utils';
import { translateX } from '@elio/shared/utils';
import { TranslocoModule } from '@ngneat/transloco';
import { ToastMessageComponent } from './toast-message.component';
import { Toast } from './toast.model';
import { ToastService } from './toast.service';

@Component({
  selector: 'elio-toast',
  templateUrl: './toast-container.component.html',
  standalone: true,
  imports: [CommonModule, ElioSvgIconsModule, ToastMessageComponent, TranslocoModule],
  styles: [
    `
      .elio-toast {
        z-index: 100000;
      }
    `,
  ],
  animations: [translateX('100%', '0%', 500)],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElioToastContainerComponent {
  toasts$ = this.toastService.toasts$;

  constructor(private toastService: ToastService) {}

  remove(toast: Toast) {
    this.toastService.remove(toast);
  }
}
